/**
 * @file: useDeviceType.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import * as Devices from 'expo-device';
import { useEffect, useRef, useState } from 'react';
import { Platform } from 'react-native';

const inferDeviceType = () => {
  // determine the default device type with heuristics.
  if (Platform.isTV) {
    return Devices.DeviceType.TV;
  }
  if (
    Platform.OS === 'web' ||
    Platform.OS === 'macos' ||
    Platform.OS === 'windows'
  ) {
    return Devices.DeviceType.DESKTOP;
  }
  if (Platform.OS === 'ios') {
    if (Devices.modelName != null && /iPad/i.test(Devices.modelName)) {
      return Devices.DeviceType.TABLET;
    }
    return Devices.DeviceType.PHONE;
  }
  if (Platform.OS === 'android') {
    if (Devices.modelName != null && /pad|tablet/i.test(Devices.modelName)) {
      return Devices.DeviceType.TABLET;
    }
    return Devices.DeviceType.PHONE;
  }
  return Devices.DeviceType.UNKNOWN;
};

const kInferredDeviceType = inferDeviceType();

export const useDeviceType = () => {
  const [deviceType, setDeviceType] =
    useState<Devices.DeviceType>(kInferredDeviceType);
  const inferredDeviceType = useRef(kInferredDeviceType);
  useEffect(() => {
    Devices.getDeviceTypeAsync()
      .then(value => {
        if (value !== inferredDeviceType.current) {
          setDeviceType(value);
        }
      })
      .catch(err => {
        console.error(err);
        setDeviceType(Devices.DeviceType.UNKNOWN);
      });
  }, []);
  return deviceType;
};
